import React, { createContext, useContext, useMemo, useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'

const PayerDataFormContext = createContext({})

function PayerDataFormProvider({ children }) {
  const [isLoading, setIsLoading] = useState(false)
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(false)
  const methods = useForm({ mode: 'all', shouldUnregister: false })

  const contextValue = useMemo(
    () => ({ isLoading, setIsLoading, isSubmitDisabled, setIsSubmitDisabled }),
    [isLoading, setIsLoading, isSubmitDisabled, setIsSubmitDisabled]
  )

  return (
    <PayerDataFormContext.Provider value={contextValue}>
      <FormProvider {...methods}>{children}</FormProvider>
    </PayerDataFormContext.Provider>
  )
}

function usePayerDataForm() {
  const context = useContext(PayerDataFormContext)
  if (!context) throw new Error('usePayerDataForm must be used within a PayerDataFormProvider')
  return context
}

export { PayerDataFormProvider, usePayerDataForm }
